<template>
  <div class="bg-white fluid-container position-fixed-top border w-lg-5 col-md-12 col-lg-6 rounded shadow p-1 p-sm-2 p-lg-4">
    <h4>Cash Sale</h4>
    
    <b-form @submit="onSubmit">
      <b-row class="m-auto">
        <b-col class="p-1">
      

      <b-form-group  label="Stude Name:" label-for="input-a">
        <b-form-input
        
          id="input-a"
          v-model="form.name"
          type="text"
          required
          placeholder="Enter Student Name"
        ></b-form-input>
      </b-form-group>

      <b-form-group  label="Parent Name:" label-for="input-a">
        <b-form-input
          id="input-a"
          v-model="form.parent_name"
          type="text"
          required
          placeholder="Enter Parent Name"
        ></b-form-input>
      </b-form-group>

      <b-form-group  label="Quantity:" label-for="input-a">
        <b-form-input
          id="input-a"
          v-model="form.qty"
          type="text"
          required
          placeholder="Enter Quantity"
        ></b-form-input>
      </b-form-group>

      <b-form-group  label="Class:" label-for="input-a">
        <b-form-input
          id="input-a"
          v-model="form.class"
          type="text"
          required
          placeholder="Enter Class"
        ></b-form-input>
      </b-form-group>

      <b-form-group  label="Email Addreess:" label-for="input-a">
        <b-form-input
          id="input-a"
          v-model="form.email_address"
          type="text"

          placeholder="Enter Email Address"
        ></b-form-input>
      </b-form-group>

      <b-form-group  label="Phone Number:" label-for="input-a">
        <b-form-input
          id="input-a"
          v-model="form.phone_number"
          type="text"
          placeholder="Enter Phone Number"
        ></b-form-input>
      </b-form-group>

        </b-col>
        <b-col  class="p-1">

        <b-form-group  label="Price:" label-for="input-a">
        <b-form-input
          id="input-a"
          v-model="form.paid"
          type="text"
          required
          placeholder="Enter Amount Paid"
        ></b-form-input>
      </b-form-group>
        
        <b-form-group  label="Performance ID:" label-for="input-a">
        <b-form-input
          id="input-a"
          v-model="form.performance_id"
          type="text"
          required
          placeholder="Enter Performance ID"
        ></b-form-input>
      </b-form-group>

      


       <b-form-group  label="Transaction ID:" label-for="input-a">
        <b-form-input
          id="input-a"
          v-model="form.txn_id"
          type="text"
          placeholder="Enter Transaction ID (surname + performance id + qty)"
        ></b-form-input>
      </b-form-group>

      

      <b-form-group  label="Type:" label-for="input-a">
        <b-form-input 
          id="input-a"
          v-model="form.type"
          type="text"
          required
          placeholder="Enter Type (DVD / Blu-Ray)"
        ></b-form-input>
      </b-form-group>

      <b-form-group  label="Date:" label-for="input-a">
        <b-form-input
          id="input-a"
          v-model="form.date_ordered"
          type="text"
          required
          placeholder="Enter Date"
        ></b-form-input>
      </b-form-group>
      
      
      
      <b-alert class="m-2"
      :show="dismissCountDown"
      dismissible
      fade
      :variant="variant"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      {{responseMSG}}
    </b-alert>

      <b-col>
        <b-button class="mt-2 w-100 w-100 " type="submit" variant="primary">Add Order</b-button>
         
        <b-button v-on:click="cancel" variant="primary" class="mt-2 w-100">Close</b-button>
      </b-col>
    </b-col>
        
    </b-row>
    </b-form>
   
    
    

  </div>
</template>

<script>
/* eslint-disable */ 


  export default {
    name: "posOrder",
    data() {
      return {
        form: {
          performance_id: '',
          name: '',
          qty: '',
          paid: '',
          class: '',
          email_address: '',
          phone_number: '',
          txn_id: '',
          parent_name: '',
          type: 'DVD',
          date_ordered: ''
        },
        dismissSecs: 5,
        dismissCountDown: 0,
        variant: 'success',
        responseMSG: '',
        performance: {}
      }
    },
    props: {
      authenticated: {}
    }, 
    methods: {
      getPerformance() {
        let currentObj = this;
        let params = new URLSearchParams();
        params.append('task', 'getPerformance');
        this.axios.post('https://www.aperturefilms.com.au/customer-portal/admin.php', params)
                .then(function (response) {
                    currentObj.performance = response.data[0]
                    console.log(currentObj.performance)
                })
                .catch(function (error) {
                    console.log(error);  
                });
      },
      onSubmit(evt) {
        evt.preventDefault()
        let currentObj = this;
        let params = new URLSearchParams();
        params.append('form', JSON.stringify(this.form))
        params.append('task', 'posOrder');
        this.axios.post('https://www.aperturefilms.com.au/customer-portal/admin.php', params)
                .then(function (response) {
                    console.log(response.data) 
                    if (response.data.success) {
                        currentObj.showAlert("success", "Order Added")
                    } else {
                        currentObj.showAlert("danger", "Order NOT Added")
                    }
                })
                .catch(function (error) {
                    console.log(error);  
                });
      },
      cancel(evt) {
          this.$emit('menuItem', false)
      },
      countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
      },
      showAlert(type, msg) {
        this.responseMSG = msg
        this.variant = type
        this.dismissCountDown = this.dismissSecs
      }

    },
    mounted() {
        this.getPerformance()
    },
    computed: {
      qty() {
        return this.form.qty;
      },
      paid() {
        return this.form.qty * this.performance.price
      }
    },
    watch: {
  
    performance: function () {
      this.form.performance_id = this.performance.performance_id
      this.form.paid = this.performance.price
      this.form.date_ordered = this.performance.date
    },
    qty: function () {
      let tmp  = this.form.parent_name + this.form.performance_id + this.form.date_ordered + this.form.qty
      this.form.txn_id = tmp.replace(/-| /g, '')
    },
    paid: function() {
      this.form.paid = this.paid
    }
  }
}
</script>
<style scoped>
.fluid-container {
    margin:  auto ;
     margin-top: 110px;


}
</style>